import ajax from 'root/src/shared/util/ajax'
import nodeAjax from 'root/src/shared/util/nodeAjax'

export default typeof window !== 'undefined' ? ajax : nodeAjax
